/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

export const QUOTE_TEMPLATES_QUERY = /* GraphQL */ `
  query QUOTE_TEMPLATES_QUERY(
    $filter: NegotiableQuoteTemplateFilterInput
    $pageSize: Int
    $currentPage: Int
    $sort: NegotiableQuoteTemplateSortInput
  ) {
    negotiableQuoteTemplates(
      filter: $filter
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      items {
        uid
        template_id
        name
        created_at
        updated_at
        last_ordered_at
        status
        state
        min_negotiated_grand_total
        last_shared_at
        expiration_date
        orders_placed
        prices {
          grand_total {
            currency
            value
          }
        }
      }
      page_info {
        current_page
        page_size
        total_pages
      }
      total_count
      sort_fields {
        default
        options {
          label
          value
        }
      }
    }
  }
`;
